
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navigation = [
    { name: 'Accueil', href: '/' },
    { name: 'À propos', href: '/about' },
    { name: 'Nos prestations', href: '/services' },
    { name: 'Projets phares', href: '/projects' },
    { name: 'Galerie', href: '/gallery' },
    { name: 'Actualités', href: '/news' },
    { name: 'Ils nous font confiance', href: '/testimonials' },
    { name: 'Contact', href: '/contact' }
  ];

  const handleNavClick = () => {
    setIsMenuOpen(false);
    // Scroll to top when navigating
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-24">
          {/* Logo */}
          <div className="flex items-center">
            <h1>
              <Link to="/" className="cursor-pointer" onClick={handleNavClick}>
                <img 
                  src="https://static.readdy.ai/image/a808dc7181425b7ee1ae1c223286d53e/5e310d77c71a35520a8427db6e7b95cb.jpeg" 
                  alt="Ideevents - Agence événementiel culture africaine" 
                  className="h-20 w-auto hover:opacity-90 transition-opacity duration-200"
                  title="Ideevents - Agence événementiel culture africaine Nantes"
                />
              </Link>
            </h1>
          </div>

          {/* Navigation desktop */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
              Accueil
            </Link>
            <Link to="/about" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
              À propos
            </Link>
            <Link to="/services" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
              Nos prestations
            </Link>
            <Link to="/projects" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
              Projets phares
            </Link>
            <Link to="/gallery" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
              Galerie / Médias
            </Link>
            <Link to="/news" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
              Actualités / Blog
            </Link>
            <Link to="/testimonials" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
              Ils nous font confiance
            </Link>
            <Link to="/contact" className="text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
              Contact
            </Link>
          </nav>

          {/* Menu mobile */}
          <div className="lg:hidden">
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="w-8 h-8 flex items-center justify-center text-gray-700 hover:text-orange-500"
            >
              <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
            </button>
          </div>
        </div>

        {/* Menu mobile ouvert */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-100">
            <div className="flex flex-col space-y-4">
              <Link to="/" className="block px-3 py-2 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
                Accueil
              </Link>
              <Link to="/about" className="block px-3 py-2 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
                À propos
              </Link>
              <Link to="/services" className="block px-3 py-2 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
                Nos prestations
              </Link>
              <Link to="/projects" className="block px-3 py-2 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
                Projets phares
              </Link>
              <Link to="/gallery" className="block px-3 py-2 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
                Galerie / Médias
              </Link>
              <Link to="/news" className="block px-3 py-2 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
                Actualités / Blog
              </Link>
              <Link to="/testimonials" className="block px-3 py-2 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
                Ils nous font confiance
              </Link>
              <Link to="/contact" className="block px-3 py-2 text-gray-700 hover:text-orange-600 transition-colors cursor-pointer" onClick={handleNavClick}>
                Contact
              </Link>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
